// Which subscription states let a member in (owner, 24 October 2026, choice A): a member whose card
// payment failed keeps access while Stripe retries the card ('past_due') and sees a notice asking them
// to update it; access ends only when Stripe gives up and cancels. The database's has_fitness_access()
// (migration 090) and Nutrition use the same list: keep them in step.
export const ACCESS_STATUSES = ['active', 'trialing', 'past_due'];

export const statusGivesAccess = (status) => ACCESS_STATUSES.includes(status);
